var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.getTimeline(_vm.ticketId) && _vm.getTimeline(_vm.ticketId).length > 0
        ? _c(
            "v-timeline",
            { attrs: { dense: "" } },
            [
              _c(
                "v-slide-x-transition",
                { attrs: { group: "" } },
                _vm._l(_vm.sortTimeLine, function (c, index) {
                  return _c(
                    "v-timeline-item",
                    {
                      key: index,
                      attrs: {
                        "fill-dot": "",
                        color: _vm.getCommentTypes[c.type].color,
                        small: "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "icon",
                            fn: function () {
                              return [
                                _vm.agentsMap[c.uid] &&
                                _vm.agentsMap[c.uid].photo
                                  ? _c("v-avatar", { attrs: { size: "24" } }, [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.agentsMap[c.uid].photo,
                                          alt: _vm.agentsMap[c.uid].name,
                                        },
                                      }),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                (c.type === _vm.$activityTypes.WHATSAPP &&
                                  !c.uid &&
                                  !c.activity_type &&
                                  !c.from_me) ||
                                c.type === _vm.$activityTypes.CONTACT
                                  ? _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          "x-small": "",
                                          color: "white",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n            fas fa-user\n          "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "px-4 py-2" },
                        [
                          _c("p", { staticClass: "mb-0" }, [
                            _vm.agentsMap[c.uid]
                              ? _c("strong", {
                                  staticClass: "pr-1",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.agentsMap[c.uid].full_name
                                    ),
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.agentsMap[c.uid]
                              ? _c("strong", [_vm._v("·")])
                              : _vm._e(),
                            _vm._v(" "),
                            c.created_at
                              ? _c("strong", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$formatTimestamp(
                                        c.created_at,
                                        "large"
                                      )
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          c.wa_referral
                            ? [
                                _c(
                                  "v-card",
                                  {
                                    staticClass:
                                      "my-2 referral-card grey lighten-4",
                                    attrs: {
                                      outlined: "",
                                      href: c.wa_referral.source_url,
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                    },
                                  },
                                  [
                                    c.wa_referral.media_type === "image" &&
                                    c.wa_referral.image_url
                                      ? _c("v-img", {
                                          attrs: {
                                            src: c.wa_referral.image_url,
                                            "max-height": "180",
                                            cover: "",
                                          },
                                        })
                                      : c.wa_referral.media_type === "video"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "referral-video-placeholder",
                                            staticStyle: {
                                              position: "relative",
                                            },
                                          },
                                          [
                                            c.wa_referral.thumbnail_url
                                              ? _c("v-img", {
                                                  attrs: {
                                                    src: c.wa_referral
                                                      .thumbnail_url,
                                                    "max-height": "180",
                                                    cover: "",
                                                  },
                                                })
                                              : _c("div", {
                                                  staticClass:
                                                    "d-flex align-center justify-center grey lighten-3",
                                                  staticStyle: {
                                                    height: "120px",
                                                  },
                                                }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-center",
                                                staticStyle: {
                                                  position: "absolute",
                                                  inset: "0",
                                                  background:
                                                    "rgba(0, 0, 0, 0.3)",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      large: "",
                                                      color: "white",
                                                    },
                                                  },
                                                  [_vm._v("fas fa-play-circle")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("v-card-text", { staticClass: "pa-2" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text text-uppercase font-weight-bold mb-1",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                "x-small": "",
                                                color: "grey",
                                              },
                                            },
                                            [_vm._v("fas fa-ad")]
                                          ),
                                          _vm._v(
                                            "\n                  Anuncio\n                "
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      c.wa_referral.headline
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "font-weight-bold text--primary",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    c.wa_referral.headline
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          c.has_media_content && c.file_url
                            ? [
                                ["image", "sticker"].includes(c.wa_message_type)
                                  ? _c("img", {
                                      staticClass: "pt-2",
                                      style: {
                                        width:
                                          c.wa_message_type === "sticker"
                                            ? "50%"
                                            : "100%",
                                      },
                                      attrs: { src: c.file_url, alt: "Image" },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                c.wa_message_type === "audio"
                                  ? _c(
                                      "audio",
                                      {
                                        staticClass: "w100 pt-2",
                                        attrs: {
                                          src: c.file_url,
                                          controls: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              Tu navegador no soporta la reproducción de audio.\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                c.wa_message_type === "video"
                                  ? _c(
                                      "video",
                                      {
                                        staticClass: "pt-2",
                                        attrs: { controls: "", width: "100%" },
                                      },
                                      [
                                        _c("source", {
                                          attrs: { src: c.file_url },
                                        }),
                                        _vm._v(
                                          "\n              Tu navegador no soporta la reproducción de video.\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                c.wa_message_type === "document"
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "mt-1",
                                        attrs: {
                                          loading:
                                            _vm.loadingMedia &&
                                            _vm.commentIdSelected === c.id,
                                          block: "",
                                          text: "",
                                          outlined: "",
                                          color: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDownloadCommentMedia(c)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { "x-small": "" } },
                                          [_vm._v("fas fa-file-download")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "ml-2 text-caption" },
                                          [_vm._v("Descargar documento")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          !c.file_url &&
                          c.wa_message_type &&
                          ["image", "document", "sticker"].includes(
                            c.wa_message_type
                          )
                            ? [
                                c.media_url
                                  ? _c("img", {
                                      style: {
                                        width:
                                          c.wa_message_type === "sticker"
                                            ? "50%"
                                            : "100%",
                                      },
                                      attrs: { src: c.media_url, alt: "Image" },
                                    })
                                  : ["image", "sticker"].includes(
                                      c.wa_message_type
                                    )
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "mt-1",
                                        attrs: {
                                          loading:
                                            _vm.loadingMedia &&
                                            _vm.commentIdSelected === c.id,
                                          block: "",
                                          text: "",
                                          outlined: "",
                                          color: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onViewCommentMedia(c)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { "x-small": "" } },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  c.wa_message_type === "image"
                                                    ? "fas fa-image"
                                                    : "far fa-sticky-note"
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "ml-2 text-caption" },
                                          [
                                            _vm._v(
                                              " Ver " +
                                                _vm._s(
                                                  c.wa_message_type === "image"
                                                    ? "imagen"
                                                    : "sticker"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : c.wa_message_type === "document"
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "mt-1",
                                        attrs: {
                                          loading:
                                            _vm.loadingMedia &&
                                            _vm.commentIdSelected === c.id,
                                          block: "",
                                          text: "",
                                          outlined: "",
                                          color: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDownloadCommentMedia(c)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { "x-small": "" } },
                                          [_vm._v("fas fa-file-download")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "ml-2 text-caption" },
                                          [_vm._v("Descargar documento")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "text-caption pb-2",
                            domProps: {
                              innerHTML: _vm._s(c.text_formatted || c.text),
                            },
                          }),
                          _vm._v(" "),
                          c.wa_location
                            ? [
                                _c(
                                  "a",
                                  {
                                    staticClass: "text-caption",
                                    attrs: {
                                      href: `https://www.google.com/maps/search/?api=1&query=${c.wa_location.latitude},${c.wa_location.longitude}`,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Ver en Google Maps\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "text-caption",
                                    attrs: {
                                      href: `http://maps.apple.com/?ll=${c.wa_location.latitude},${c.wa_location.longitude}`,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Ver en Apple Maps\n            "
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          c.order_id
                            ? _c(
                                "div",
                                { staticClass: "mb-1" },
                                [
                                  c.products
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "pr-5",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "h6",
                                            {
                                              staticClass: "text-caption mb-2",
                                            },
                                            [_vm._v("Productos relacionados:")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-simple-table",
                                            {
                                              staticClass: "mb-4",
                                              staticStyle: {
                                                "overflow-x": "auto",
                                                border: "1px solid lightgrey",
                                              },
                                            },
                                            [
                                              _c(
                                                "thead",
                                                {
                                                  staticClass: "grey lighten-4",
                                                },
                                                [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                      },
                                                      [_vm._v("Nombre")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                      },
                                                      [_vm._v("Cantidad")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                      },
                                                      [_vm._v("Subtotal")]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "tbody",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._l(
                                                    c.products,
                                                    function (product, i) {
                                                      return _c(
                                                        "tr",
                                                        { key: i },
                                                        [
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                product.name ||
                                                                  product.id
                                                              )
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                product.quantity
                                                              )
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$formatCurrency(
                                                                  product.price *
                                                                    product.quantity
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-right subtitle",
                                                        attrs: {
                                                          colspan: " 2",
                                                        },
                                                      },
                                                      [_vm._v("Total")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "grey lighten-5",
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "primary--text subtitle",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$formatCurrency(
                                                                  c.total_products
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ],
                                                2
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  ![
                                    _vm.$roles.ADVISOR,
                                    _vm.$roles.SUPERVISOR,
                                  ].includes(_vm.getAgent.role)
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            text: "",
                                            small: "",
                                            to: {
                                              name: "order_detail",
                                              params: { id: c.order_id },
                                            },
                                            target: "_blank",
                                            color: "primary",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "pr-2",
                                              attrs: { "x-small": "" },
                                            },
                                            [
                                              _vm._v(
                                                " fas fa-external-link-alt "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            " Ver detalle de la orden\n            "
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex justify-space-between" },
                            [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "my-1 mr-1",
                                  attrs: {
                                    color: _vm.getCommentTypes[c.type].color,
                                    rounded: "",
                                    outlined: "",
                                    small: "",
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", size: "12" } },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.getCommentTypes[c.type].icon
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  c.type == _vm.$activityTypes.CALL
                                    ? _c("span", [_vm._v("Llamada")])
                                    : c.type ==
                                      _vm.$activityTypes.COMMENT_BY_AGENT
                                    ? _c("span", [
                                        _vm._v("Comentario del agente"),
                                      ])
                                    : c.type == _vm.$activityTypes.EVENT
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              `${c.event_date} ${
                                                c.event_time
                                              } ${
                                                c.event_time_end
                                                  ? ` - ${c.event_time_end}`
                                                  : ""
                                              }`
                                            ) +
                                            "\n              "
                                        ),
                                      ])
                                    : c.type == _vm.$activityTypes.WHATSAPP
                                    ? _c("span", [_vm._v("WhatsApp")])
                                    : c.type == _vm.$activityTypes.FOLLOW_UP
                                    ? _c("span", [_vm._v("Seguimiento")])
                                    : _c("span", [_vm._v("Comentario")]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  !c.from_me &&
                                  c.type == _vm.$activityTypes.WHATSAPP
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            loading:
                                              _vm.loadingMedia &&
                                              _vm.commentIdSelected === c.id,
                                            icon: "",
                                            small: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onOpenAssistantLogModal(
                                                c.text
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { "x-small": "" } },
                                            [_vm._v("fas fa-clipboard-list")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  c.media_url
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            loading:
                                              _vm.loadingMedia &&
                                              _vm.commentIdSelected === c.id,
                                            icon: "",
                                            small: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDownloadCommentMediaImage(
                                                c
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { "x-small": "" } },
                                            [_vm._v("fas fa-download")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  c.message_template_id &&
                                  _vm.messageTemplatesMap[c.message_template_id]
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onOpenMessageTemplatePreviewModal(
                                                _vm.messageTemplatesMap[
                                                  c.message_template_id
                                                ]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { "x-small": "" } },
                                            [_vm._v("fas fa-eye")]
                                          ),
                                        ],
                                        1
                                      )
                                    : c.formatted_message
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onOpenMessagePreviewModal(
                                                c.formatted_message
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { "x-small": "" } },
                                            [_vm._v("fas fa-eye")]
                                          ),
                                        ],
                                        1
                                      )
                                    : c.reply_message
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onOpenReplyMessagePreviewModal(
                                                c.reply_message
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { "x-small": "" } },
                                            [_vm._v("fas fa-eye")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  c.wa_id
                                    ? [
                                        c.status === "read"
                                          ? _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  color: "blue",
                                                },
                                              },
                                              [_vm._v("fas fa-check-double")]
                                            )
                                          : c.status === "delivered"
                                          ? _c(
                                              "v-icon",
                                              { attrs: { "x-small": "" } },
                                              [_vm._v("fas fa-check-double")]
                                            )
                                          : c.status === "failed"
                                          ? _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  color: "red",
                                                },
                                              },
                                              [_vm._v(" fas fa-times ")]
                                            )
                                          : _c(
                                              "v-icon",
                                              { attrs: { "x-small": "" } },
                                              [_vm._v("fas fa-check")]
                                            ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          c.wa_id && c.status === "failed"
                            ? _c(
                                "v-alert",
                                {
                                  staticClass: "mb-0 mt-2 text-caption",
                                  attrs: {
                                    icon: false,
                                    text: "",
                                    dense: "",
                                    type: "error",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        c.error
                                          ? c.error.message
                                          : "Ocurrió un problema al enviar el mensaje"
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          c.type === _vm.$activityTypes.EVENT &&
                          c.uid === _vm.getAgent.uid
                            ? _c(
                                "div",
                                { staticClass: "text-right pa-2" },
                                [
                                  _c("BtnCalendar", {
                                    attrs: {
                                      "event-id": c.id,
                                      date: c.event_date,
                                      "hour-start": c.event_time,
                                      "hour-end": c.event_time_end,
                                      title: c.event_name,
                                      detail: c.detail,
                                    },
                                    on: {
                                      "update:eventId": function ($event) {
                                        return _vm.$set(c, "id", $event)
                                      },
                                      "update:event-id": function ($event) {
                                        return _vm.$set(c, "id", $event)
                                      },
                                      "update:date": function ($event) {
                                        return _vm.$set(c, "event_date", $event)
                                      },
                                      "update:hourStart": function ($event) {
                                        return _vm.$set(c, "event_time", $event)
                                      },
                                      "update:hour-start": function ($event) {
                                        return _vm.$set(c, "event_time", $event)
                                      },
                                      "update:hourEnd": function ($event) {
                                        return _vm.$set(
                                          c,
                                          "event_time_end",
                                          $event
                                        )
                                      },
                                      "update:hour-end": function ($event) {
                                        return _vm.$set(
                                          c,
                                          "event_time_end",
                                          $event
                                        )
                                      },
                                      "update:title": function ($event) {
                                        return _vm.$set(c, "event_name", $event)
                                      },
                                      "update:detail": function ($event) {
                                        return _vm.$set(c, "detail", $event)
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _c("div", { staticClass: "text-center py-4" }, [
            _vm._v("Aún no hay comentarios"),
          ]),
      _vm._v(" "),
      _vm.dialogWhatsappMessageTemplatePreview
        ? _c("MessageTemplatePreviewModal", {
            attrs: {
              dialog: _vm.dialogWhatsappMessageTemplatePreview,
              "message-template-selected": _vm.whatsappMessageTemplate,
            },
            on: {
              "update:dialog": function ($event) {
                _vm.dialogWhatsappMessageTemplatePreview = $event
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogWhatsappReplyMessagePreview
        ? _c("ReplyMessagePreviewModal", {
            attrs: {
              dialog: _vm.dialogWhatsappReplyMessagePreview,
              "reply-message-selected": _vm.whatsappReplyMessage,
            },
            on: {
              "update:dialog": function ($event) {
                _vm.dialogWhatsappReplyMessagePreview = $event
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogWhatsappMessagePreview
        ? _c("MessagePreviewModal", {
            attrs: {
              dialog: _vm.dialogWhatsappMessagePreview,
              message: _vm.whatsappMessage,
            },
            on: {
              "update:dialog": function ($event) {
                _vm.dialogWhatsappMessagePreview = $event
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogAssistantLog
        ? _c("AssistantLogModal", {
            attrs: {
              dialog: _vm.dialogAssistantLog,
              "ticket-id": _vm.ticketId,
              input: _vm.input,
            },
            on: {
              "update:dialog": function ($event) {
                _vm.dialogAssistantLog = $event
              },
              "update:ticketId": function ($event) {
                _vm.ticketId = $event
              },
              "update:ticket-id": function ($event) {
                _vm.ticketId = $event
              },
              "update:input": function ($event) {
                _vm.input = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }